import config from "../../config/enviroment";
var paymentMethods = [
    {
        name: "Master Card",
        image: config.urlS3 + "/wom/paymentMethods/mastercard.png",
    },
    {
        name: "Visa",
        image: config.urlS3 + "/wom/paymentMethods/visa.png",
    },
    {
        name: "Americanexpress",
        image: config.urlS3 + "/wom/paymentMethods/AM.png",
    },
    {
        name: "Dinersclub",
        image: config.urlS3 + "/wom/paymentMethods/DC.png",
    },
    {
        name: "pse",
        image: config.urlS3 + "/wom/paymentMethods/pse.png",
    },
    {
        name: "Codensa",
        image: config.urlS3 + "/wom/paymentMethods/codensa.png",
    },
    {
        name: "Daviviplata",
        image: config.urlS3 + "/wom/paymentMethods/daviplata.png",
    },
];
export default paymentMethods;
